import React from 'react';
import './EventScreen.css';

// Import Visual Assets
import backButton from './img/ic_back1 1.png';

/**
 * Event Screen
 */
class EventScreen extends React.Component {
  renderDateTime(dateOccurred) {
    if (dateOccurred === "") {
      return (
        <div id="event-datetime">
          <span id="event-datetime-text">Access This Event Anytime</span>
        </div>
      );
    } else {
      let hours = dateOccurred.substring(11, 13);
      let minutes = dateOccurred.substring(14, 16);
      let AmOrPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;

      return (
        <p id="event-datetime">
          <span id="event-datetime-text">{new Date(dateOccurred).toDateString()} @ {hours + ":" + minutes + " " + AmOrPm}</span>
        </p>
      );
    }
  }

  renderDescription(description) {
    if (description !== "") {
      let output = [];

      let lines = description.split("\n");
      var expression = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
      var regex = new RegExp(expression);

      for (let i = 0; i < lines.length; i++) {
        if (lines[i].match(regex)) {
          output.push(
            <div key={i}>
              <button
                className="event-button"
                onClick={() => {
                  // this.props.changeScreen("Feedback");
                  window.open(lines[i], "_blank");
                }}>
                Proceed To Activity
                </button><br />
            </div>
          );
        } else {
          output.push(
            <div key={i}>
              <p>
                {lines[i]}
              </p>
            </div>
          );
        }
      }

      // console.log(output);

      return (
        <div className="event-section" id="event-description">
          <p className="event-section-title">Description</p>
          {output}
        </div>
      );
    }
  }

  renderSkills(skills) {
    if (skills.length > 0) {
      return (
        <div className="event-section" id="event-skills">
          <p className="event-section-title">Skills</p>
          {skills.map((skill, index) => (
            <span key={index} className="event-skill">
              {skills[index]}
            </span>
          ))}
          <br/><br/>
        </div>
      );
    }
  }

  renderLocation(location) {
    if (location !== "") {
      return (
        <p className="event-location">
          Location: {location}
        </p>
      );
    }
  }

  renderFeedback() {
    console.log(this.props.event.feedbackForm);
    return (
      <div className="event-section" id="event-feedback">
        <p className="event-section-title">Feedback Instructions</p>
        <p>Did you finish completing the activity? If so, <b>fill out this <a href= {this.props.event.feedbackForm !== undefined && this.props.event.feedbackForm !== "" ? this.props.event.feedbackForm : "https://docs.google.com/forms/d/e/1FAIpQLSePPw5epXINR9iorFi6S5YFc6b-KgG6BwmF_aSPYEQNN24RoA/viewform"} target="_blank" rel="noopener noreferrer">feedback form</a> to receive a $5 e-gift card.</b></p>
        <p>If you haven't finished filling out the <a href="https://yalesurvey.ca1.qualtrics.com/jfe/form/SV_eew48DZxmhq4wJv" target="_blank" rel="noopener noreferrer">demographic survey</a>, please do so now.</p>
        <p>Thank you for using DreamKit!</p>
      </div>
    )
  }

  render() {
    return (
      <div id="event-screen">
        <div className="container-fluid">
          <div className="row">

            <div id="event-header">
              <img id="back-button" src={backButton} alt="Close Button" onClick={() => this.props.changeSelectedEvent("")} />
              <div id="event-title">{this.props.event.title}</div>
              <div id="event-category">{this.props.event.category}</div>
              {this.renderDateTime(this.props.event.dateOccurred)}
            </div>

            <br />

            <div id="event-body">
              {this.renderDescription(this.props.event.description)}
              {this.renderSkills(this.props.event.skills)}
              {this.renderLocation(this.props.event.location)}
              {this.renderFeedback()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventScreen;